import { Warning, WarningLevel } from 'editor/src/store/editorModules/warnings/types';

import {
  FRAME_PROPS_HIGH_WARNING,
  FRAME_PROPS_MEDIUM_WARNING,
} from 'editor/src/component/EditorArea/Spread/Page/MediaElement/Image/elementsConstantProps';

/** Frame colour of an element with warnings, the strictest level wins; undefined keeps the normal frame. */
function getWarningFrameColor(warnings: Pick<Warning, 'level'>[]): string | undefined {
  if (warnings.some(({ level }) => level === WarningLevel.High)) {
    return FRAME_PROPS_HIGH_WARNING.borderColor;
  }
  if (warnings.some(({ level }) => level === WarningLevel.Medium)) {
    return FRAME_PROPS_MEDIUM_WARNING.borderColor;
  }
  return undefined;
}

export default getWarningFrameColor;
